import { StyleSheet } from 'react-native';

import { androidScreenMarginBottom } from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        marginBottom: androidScreenMarginBottom,
    },
    svgButton: {
        position: 'absolute',
        right: 44,
        top: 24,
    },
    icon: {
        marginBottom: 16,
    },
});

export default styles;
